import dayjs, { Dayjs } from 'dayjs'

/**
 * Returns true if the date string parses to a valid date within
 * `yearsBack` years in the past and `yearsForward` years in the future.
 * Rejects irrational years (e.g. 0025) automatically via the range check.
 */
export function isDateInRange(
  dateString: string | null | undefined,
  yearsBack = 1,
  yearsForward = 1
): boolean {
  if (!dateString) return false
  const d = dayjs(dateString)
  if (!d.isValid()) return false
  const todayStart = dayjs().startOf('day')
  return (
    !d.isBefore(todayStart.subtract(yearsBack, 'year')) &&
    !d.isAfter(todayStart.add(yearsForward, 'year'))
  )
}

/**
 * Returns true if the date string parses to a valid date.
 */
export function isValidDate(date: string | undefined | null | Dayjs): boolean {
  if (date === null || date === undefined || date === '') return false
  const dateObj = dayjs(date)
  return dateObj.isValid()
}
